export default import.meta.ROLLDOWN_FILE_URL_2LWbSWAvfunqN68WgbME5g